import { useRef, useState, useEffect } from "react";
import { useToast } from "@salesapp/ui";
import { api } from "../lib/api";
import { useAuth } from "./AuthProvider";
import { useTheme, type ThemeMode } from "./ThemeProvider";
import { ThemeToggle } from "./ThemeToggle";

export function AccountThemeToggle() {
  const { session } = useAuth();
  const { setMode } = useTheme();
  const toast = useToast();
  const [saving, setSaving] = useState(false);
  const identity = useRef(session?.userId);
  useEffect(() => { identity.current = session?.userId; }, [session?.userId]);
  async function change(mode: ThemeMode) {
    const userId = session?.userId;
    setMode(mode);
    if (!userId) return;
    setSaving(true);
    try { await api.patch("/auth/preferences/theme", { display_theme: mode }); }
    catch {
      if (identity.current === userId) toast.show("Theme changed on this device, but could not be saved to your account. Please try again.", "danger");
    } finally { setSaving(false); }
  }
  return <ThemeToggle onChange={(mode) => { if (!saving) void change(mode); }} />;
}
